// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import { PageHeader } from "@/components/layout/page-header";
import { RequirePermission } from "@/components/shared/require-permission";
import { OctoVisualizer } from "@/features/octo/octo-visualizer";
import { PAGE_PERMISSIONS } from "@/lib/auth/page-permissions";

export const Route = createFileRoute("/_authenticated/octo/visualizer/")({
  component: () => (
    <RequirePermission permission={PAGE_PERMISSIONS.octoVisualizer}>
      <VisualizerPage />
    </RequirePermission>
  ),
  validateSearch: z.object({ f: z.string().optional() }),
});

function VisualizerPage() {
  const { t } = useTranslation("back-office");
  const { f } = Route.useSearch();

  return (
    <div>
      <PageHeader title={t("visualizer.title")} />
      <div className="p-6">
        <OctoVisualizer initialFilters={f} />
      </div>
    </div>
  );
}
